import { all, call, put, race, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { payActions } from '$store/pay/index';
import { PayMethod } from '$store/pay/interface';
import { batchActions } from '$store';
import { Api } from '$api';
import { mainActions } from '$store/main';
import { paymentMethodsActions } from '$store/paymentMethods';

interface PaySagaParams {
  amount: number;
  title: string;
  description?: string;
  availableMethods?: PayMethod[];
  excludeFiat?: boolean;
}

export function* paySaga({ title, description, ...params }: PaySagaParams) {
  yield put(
    batchActions(
      payActions.show({
        title: title,
        description: description,
      }),
      payActions.setAvailableMethods(
        (
          params.availableMethods || [
            PayMethod.BALANCE,
            PayMethod.CRYPTOPAY,
            PayMethod.CARD,
            PayMethod.TONKEEPER,
          ]
        ).filter((m) => !params.excludeFiat || m !== PayMethod.CARD),
      ),
      payActions.setAmount(params.amount),
    ),
  );
  const { method } = yield race({
    method: take(payActions.chooseMethod),
    cancel: take(payActions.cancel),
  });

  if (
    method &&
    method.payload.method !== PayMethod.CRYPTOPAY &&
    method.payload.method !== PayMethod.TONKEEPER
  ) {
    yield put(payActions.cancel());
  }

  return {
    method: method?.payload.method || null,
    options: method?.payload.options || {},
  };
}

function* getRatesWorker() {
  yield put(payActions.setLoadingRates(true));
  const rates = yield call(Api.post, '/rates');
  yield put(payActions.setRates(rates));
  yield put(payActions.setLoadingRates(false));
}

export function* getCardWorker() {
  const data = yield call(Api.get, '/main/init'); // TODO: implement new endpoint for get card info
  yield put(mainActions.setCard(data.card || null));
  yield put(paymentMethodsActions.loadCards());
}

function* loadTopUpMethodsWorker() {
  try {
    const data = yield call(Api.get, '/pay/methods');
    yield put(payActions.setTopUpMethods(data?.methods || []));
  } catch (e) {
    yield put(payActions.setTopUpMethods([]));
  }
}

export function* paySagaRoot() {
  yield all([
    takeEvery(payActions.getRates, getRatesWorker),
    takeLatest(payActions.loadTopUpMethods, loadTopUpMethodsWorker),
  ]);
}
